import { render, staticRenderFns } from "./resume-about.vue?vue&type=template&id=7f74c480&"
import script from "./resume-about.vue?vue&type=script&lang=js&"
export * from "./resume-about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports